import breakpoints from '../../theme/breakpoints'

import css from 'styled-jsx/css'

export default css.div`
  .collection {
    display: flex;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-bottom: 4px;
    flex-wrap: wrap;
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .collection-container {
      margin: 74px 16px 24px 16px;
    }
    
    .collection {
      margin-top: 24px;
    }
  }
`
